import { setMilliseconds, sub } from 'date-fns';
import { createWithEqualityFn as create } from 'zustand/traditional';

import { INBOUND_VIEW_BY, InboundViewByValue } from 'components/insights/careTransitions/inboundReferrals/constants';
import { DATES, END_DATE, START_DATE } from 'constants/filterKeysConstants';

import { FilterOption, FilterState } from './types';

const now = setMilliseconds(new Date(), 0);
const thirtyDaysAgo = sub(now, { days: 30 });

export type InboundReferralsInsightsFilterState = FilterState<FilterOption[] | string | Date>;

type Actions = {
  setViewBy: (viewBy: InboundViewByValue) => void;
  setSelectedFilters: (filters: InboundReferralsInsightsFilterState) => void;
  setExpanded: (expanded: boolean) => void;
  resetFilters: () => void;
};

type State = {
  viewBy: InboundViewByValue;
  filters: InboundReferralsInsightsFilterState;
  expanded: boolean;
  actions: Actions;
};

const defaultFilters = (): InboundReferralsInsightsFilterState => ({
  [START_DATE]: thirtyDaysAgo,
  [END_DATE]: now,
});

export const useInboundReferralsInsightsStore = create<State>((set) => ({
  viewBy: INBOUND_VIEW_BY.RECEIVING_SNF,
  filters: defaultFilters(),
  expanded: false,
  actions: {
    setViewBy: (viewBy) => set({ viewBy }),
    setSelectedFilters: (filters) => set((state) => ({ filters: { ...state.filters, ...filters } })),
    setExpanded: (expanded) => set({ expanded }),
    resetFilters: () => set({ viewBy: INBOUND_VIEW_BY.RECEIVING_SNF, filters: defaultFilters() }),
  },
}));

export const useInboundReferralsInsightsActions = () => useInboundReferralsInsightsStore((state) => state.actions);

export const getInboundReferralAnalyticsFilters = ({ filters }: State) => {
  const { [START_DATE]: start, [END_DATE]: end, ...rest } = filters;
  return {
    ...rest,
    [DATES]: [{ start, end }],
  };
};
